import { render, staticRenderFns } from "./TextAreaField.vue?vue&type=template&id=bb9dfaf8&scoped=true&"
import script from "./TextAreaField.vue?vue&type=script&lang=js&"
export * from "./TextAreaField.vue?vue&type=script&lang=js&"
import style1 from "./TextAreaField.vue?vue&type=style&index=1&id=bb9dfaf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9dfaf8",
  null
  
)

export default component.exports